import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { INotification } from '@shared';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationComponent {
  @Input()
  notification: INotification | null = null;
}
